module.exports = __webpack_public_path__ + "img/13.8fbd81f7.png";